import { ExternalToolWebLinkTypes } from 'redux/schemas/models/external-tool';

/* @ngInject */
export default function WebLinkLectureComponentModel(
  EmbedLectureComponentModel,
) {
  return EmbedLectureComponentModel.create(ExternalToolWebLinkTypes.WEB_LINK);
}
